import React from "react";

import HeroSection from "../components/shared/HomeCategories/HeroSection";
import HomeSection1 from "../components/shared/HomeCategories/Section1";
import HomeSection2 from "../components/shared/HomeCategories/Section2";
import HomeSection3 from "../components/shared/HomeCategories/Section3";
import Banner from "../components/shared/HomeCategories/Banner";
import HomeSection4 from "../components/shared/HomeCategories/Section4";
import HomeSection5 from "../components/shared/HomeCategories/Section5";
import Section4 from "../components/shared/HomeCategories/BusinessSection/Section4";
import Section5 from "../components/shared/HomeCategories/BusinessSection/Section5";
import Section7 from "../components/shared/HomeCategories/BusinessSection/Section7";
import HomeSection6 from "../components/shared/HomeCategories/BusinessSection";
import HomeSection7 from "../components/shared/HomeCategories/Section7";
import HomeSection8 from "../components/shared/HomeCategories/Section8";
import HomeSection9 from "../components/shared/HomeCategories/Section9";
import Office from "../components/shared/HomeCategories/Office";
import KidsFavorite from "../components/shared/HomeCategories/KidsFavorite";

const HomeScreen = () => {
  return (
    <>
      <div>
        {/* Hero Section */}
        <HeroSection />

        {/* Card- Categories */}
        {/* Section1 */}
        <div id="section-1">
          <HomeSection1 />
        </div>

        {/* Section2 */}
        <div id="section-2">
          <HomeSection2 />
        </div>

        {/* Section3 */}
        <div id="section-3">
          <HomeSection3 />
        </div>

        {/* Personalized Banner */}
        <div id="banner">
          <Banner />
        </div>

        {/* Personalized Section */}
        <HomeSection4 />

        {/* Themed Section */}
        <div id="section-5">
          <HomeSection5 />
        </div>

        {/* Kids favorite Section */}
        <div id="kids-favorite">
          <KidsFavorite />
        </div>

        {/* Business Section*/}
        <div id="section-6">
          <HomeSection6 />
        </div>

        {/* Section7 */}
        <div id="section-7">
          <HomeSection7 />
        </div>

        {/* Section8 */}
        <HomeSection8 />

        {/* Section9 */}
        <div id="section-9">
          <HomeSection9 />
        </div>
      </div>
    </>
  );
};

export default HomeScreen;
